import { render, staticRenderFns } from "./AssignmentFeedbacks.vue?vue&type=template&id=a6dbc87a&scoped=true"
import script from "./AssignmentFeedbacks.vue?vue&type=script&lang=js"
export * from "./AssignmentFeedbacks.vue?vue&type=script&lang=js"
import style0 from "./AssignmentFeedbacks.vue?vue&type=style&index=0&id=a6dbc87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dbc87a",
  null
  
)

export default component.exports